import { useCountdown } from './use-countdown';

interface UseAutoReloadOptions {
  delay?: number;
  onReload?: () => void;
  enabled?: boolean;
}

export const useAutoReload = ({
  delay = 5,
  onReload = (): void => window.location.reload(),
  enabled = true,
}: UseAutoReloadOptions = {}): number => {
  const { seconds } = useCountdown({
    initialSeconds: delay,
    onComplete: onReload,
    enabled,
  });

  return seconds;
};
